// NOTE: This component is heavily tailored to the sticky ad unit on mobile
// post pages. Long term we should remove this (if we do not keep the sticky ad),
// or make it more generic/configurable...
import { element, number } from 'prop-types';
import React, { Component } from 'react';
import Close from 'components/Icons/Close';
import styles from './styles';

class StickyBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // Hide on load...
      isActive: false
    };
    this.initialize = this.initialize.bind(this);
    this.hide = this.hide.bind(this);
    this.timeout = undefined;
  }
  componentDidMount() {
    // Reveal on scroll
    window.addEventListener('scroll', this.initialize, false);
  }
  componentWillUnmount() {
    if (this.timeout) {
      window.clearTimeout(this.timeout);
    }
    window.removeEventListener('scroll', this.initialize, false);
  }
  initialize() {
    window.removeEventListener('scroll', this.initialize, false);
    this.setState(
      {
        // Show banner
        isActive: true
      },
      () => {
        // Set timeout to hide banner (if hideAfter is set)
        if (this.props.hideAfter) {
          this.timeout = window.setTimeout(
            this.hide,
            this.props.hideAfter * 1000
          );
        }
      }
    );
  }
  hide() {
    this.setState({
      isActive: false
    });
  }
  render() {
    return (
      <span>
        <div
          className={`StickyBanner StickyBanner__${
            this.state.isActive ? 'active' : 'inactive'
          }`}
          style={{
            opacity: this.state.isActive ? 1 : 0
          }}
        >
          <button
            className="StickyBanner__dismiss"
            aria-label="close"
            type="button"
            onClick={this.hide}
          >
            <Close />
          </button>
          <div className="StickyBanner__content">
            {this.state.isActive && this.props.children}
          </div>
        </div>
        <style jsx>{styles}</style>
      </span>
    );
  }
}

StickyBanner.defaultProps = {
  hideAfter: undefined
};

StickyBanner.propTypes = {
  hideAfter: number,
  children: element.isRequired
};

export default StickyBanner;
